import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { recommendPopupFragment } from "./queries";
import { RecommendEmailSendTest } from "./types/RecommendEmailSendTest";
import { RecommendPopupDefaultCreate } from "./types/RecommendPopupDefaultCreate";
import {
  RecommendPopupUpdate,
  RecommendPopupUpdateVariables
} from "./types/RecommendPopupUpdate";
const recommendPopupUpdate = gql`
  ${recommendPopupFragment}
  mutation RecommendPopupUpdate($id: ID!, $input: RecommendPopupInput!) {
    recommendPopupUpdate(id: $id, input: $input) {
      recommendPopup {
        ...RecommendPopupFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useRecommendPopupUpdateMutation = makeMutation<
  RecommendPopupUpdate,
  RecommendPopupUpdateVariables
>(recommendPopupUpdate);

const recommendPopupDefaultCreate = gql`
  ${recommendPopupFragment}
  mutation RecommendPopupDefaultCreate {
    recommendPopupDefaultCreate {
      recommendPopup {
        ...RecommendPopupFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useRecommendPopupDefaultCreateMutation = makeMutation<
  RecommendPopupDefaultCreate,
  null
>(recommendPopupDefaultCreate);

const recommendEmailSendTest = gql`
  mutation RecommendEmailSendTest {
    recommendEmailSendTest {
      errors {
        field
        message
      }
    }
  }
`;

export const useRecommendEmailSendTestMutation = makeMutation<
  RecommendEmailSendTest,
  null
>(recommendEmailSendTest);
